import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import styles from '@/views/pages/SimpleTextAdvicesAdmin/SimpleTextAdvicesAdmin.module.scss';
import AdminMenu from '@/views/pages/SimpleTextAdvicesAdmin/parts/AdminMenu';
import CustomSelect from '@/views/components/CustomSelect/CustomSelect';

const TableSubmited = ({questions, getQuestions, handleChangesort, sortValue, sortOptions, pages, setAlert}) => {
	const dict = useSelector(state => state.app.dict);

	return (
		<>
			<div className={ `${styles[`admin__table__buttons${pages > 0 ? '-absolute' : ''}`]}` }>
				<div className={ `${styles['admin__table__select']}` }>
					<CustomSelect
						options={ sortOptions } 
						value={ sortValue }
						onChange={ handleChangesort }
						placeholder=""
						label={ dict.simpleTextAdvices.admin.sort }
						inline
					/> 
				</div>
			</div>
			<div className={ `${styles['admin__table__header-container']}` }>
				<div className={ `${styles['admin__table__head']} ${styles['admin__table__head--manage']}` }>
					<div>
						{dict.simpleTextAdvices.admin.tableSubmited.label.id}
					</div>
					<div >
						{dict.simpleTextAdvices.admin.tableSubmited.label.provider}
					</div>
					<div >
						{dict.simpleTextAdvices.admin.tableSubmited.label.department}
					</div>
					<div >
						{dict.simpleTextAdvices.admin.tableSubmited.label.sendDate}
					</div>
					<div>
						{dict.simpleTextAdvices.admin.tableSubmited.label.editionDate}
					</div>
					<div></div>
				</div>
			</div>
			{questions && questions.map(question => 
				(
					<div key={ question.id }
						className={ `${styles['admin__table__item']} ${styles['admin__table__item--manage']}` }>
						<div className={ styles['admin__table__cell'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tableSubmited.label.id}</p>
							<Link className={ styles['admin__table__link'] }
								to={ `/simple-text-advice/${question.id}?admin-advices` }>{dict.simpleTextAdvices.admin.tableSubmited.question} {question.id}</Link>
							<p className={ styles['admin__table__content'] }>{question.content}</p>
						</div>
						<div className={ `${styles['admin__table__cell']} ${styles['admin__table__item--col']}` } >
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tableSubmited.label.provider}</p>
							<p className={ styles['admin__table__text'] } >{question.author.displayName}</p>
							<p className={ styles['admin__table__tooltip'] }>{question.author.email}</p>
						</div>
						<div className={ styles['admin__table__item--col'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tableSubmited.label.department}</p>
							<p className={ styles['admin__table__text'] } >{question?.author?.departments[0]?.name}</p>
						</div>
						<div className={ styles['admin__table__item--col'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tableSubmited.label.sendDate}</p>
							<p className={ styles['admin__table__text'] } >{question.createdOn.replaceAll('-', '.')}</p>
						</div>
						<div className={ styles['admin__table__item--col'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tableSubmited.label.editionDate}</p>
							<p className={ styles['admin__table__text'] } >{question.updatedOn.replaceAll('-', '.')}</p>
						</div>
						<div 
							className={ styles['admin__table__item--col'] } 
							style={ { overflow: "unset" } }
						>
							{ question.status.code !== 'in-progress' && <AdminMenu 
								question={ question }
								getQuestions={ getQuestions }
								setAlert={ setAlert }
							/>}
						</div>
					</div>
				),
			)}
		</>
	);
};

export default TableSubmited;